import { render, staticRenderFns } from "./CorpButton.vue?vue&type=template&id=bc50f56c&scoped=true"
import script from "./CorpButton.vue?vue&type=script&lang=js"
export * from "./CorpButton.vue?vue&type=script&lang=js"
import style0 from "./CorpButton.scss?vue&type=style&index=0&id=bc50f56c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc50f56c",
  null
  
)

export default component.exports